export default __webpack_public_path__ + "static/media/info-circle.9481964d.svg";